var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGates = function SvgGates(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 413,
    height: 413,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 413 413",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.94 90.93h33.36v294.89h-33.36z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.22,
    cy: 64.57,
    r: 14.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.83,
    cy: 64.57,
    r: 14.68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.89 106.65v254.32h139.02V51.11c-51.86-9.85-87.81 39.41-139.02 55.54m109.9 66.57c5.61 0 10.2 4.59 10.2 10.2v39.41c0 5.61-4.59 10.2-10.2 10.2s-10.2-4.59-10.2-10.2v-39.41c0-5.61 4.59-10.2 10.2-10.2M350.49 106.65v254.32H211.48V51.11c51.86-9.85 87.8 39.41 139.01 55.54M240.1 173.22c5.61 0 10.2 4.59 10.2 10.2v39.41c0 5.61-4.59 10.2-10.2 10.2-5.62 0-10.21-4.59-10.21-10.2v-39.41c0-5.61 4.59-10.2 10.21-10.2M14.68 90.93h33.36v294.89H14.68z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGates);
export default ForwardRef;